import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

import Bluedart from "../assets/bluedart.png";
import Delehivery from "../assets/delehivery.png";
import EcomExpress from "../assets/ecom-expresss.avif";
import Shadowfax from "../assets/shadowfax.png";
import Xpressbees from "../assets/xpressbees.png";
import Shiprocket from "../assets/shiprocket.webp";
import NimbusPost from "../assets/nimbuspost.webp";
import ShreeMaruti from "../assets/shreemaruti.png";
import DTDC from "../assets/dtdc.png";
import { FaTruck, FaPlane, FaInfoCircle } from "react-icons/fa";
import Amazon from "../assets/amazon.jpg";
import ThreeDotLoader from "../Loader";

const carrierLogos = {
  Bluedart,
  Delhivery: Delehivery,
  EcomExpress,
  Shadowfax,
  Xpressbees,
  NimbusPost,
  Shiprocket,
  ShreeMaruti,
  DTDC,
  Amazon
};

// Modal for breakdown
const ChargeBreakdownModal = ({ open, onClose, details }) => {
  if (!open || !details) return null;
  const w = details.working || {};
  const displayValue = (v) => (v === undefined || v === null || v === "" ? "-" : v);
  const rows = [
    { label: "Chargeable Wt.", value: w.chargeable_weight ? `${w.chargeable_weight} kg` : "-" },
    { label: "Rate", value: w.rate != null ? `₹${w.rate}` : "-" },
    { label: "Freight", value: w.freight != null ? `₹${w.freight}` : "-" },
    { label: "Handling Charges", value: w.handling_charges != null ? `₹${w.handling_charges}` : "-" },
    { label: "ODA", value: w.oda != null ? `₹${w.oda}` : "-" },
    { label: "FSC", value: w.fsc != null ? `₹${w.fsc}` : "-" },
    { label: "AWB Charges", value: w.awb_charges != null ? `₹${w.awb_charges}` : "-" },
    { label: "ROV", value: w.rov != null ? `₹${w.rov}` : "-" },
    { label: "COD Charges", value: w.cod_charges != null ? `₹${w.cod_charges}` : "-" },
    { label: "FM Charges", value: w.fm_charges != null ? `₹${w.fm_charges}` : "-" },
    { label: "Total (before GST)", value: w.total != null ? `₹${w.total}` : "-" },
    { label: "GST", value: w.gst != null ? `₹${w.gst}` : "-" },
    { label: "Estimated Grand Total", value: w.grand_total != null ? `₹${w.grand_total}` : "-" }
  ];
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg w-full max-w-md p-6 relative shadow-lg">
        <h2 className="text-lg font-bold mb-2 text-gray-700">Rate Breakdown</h2>
        <div className="max-h-96 overflow-y-auto">
          <table className="w-full text-sm">
            <tbody>
              {rows.map((r, idx) => (
                <tr key={idx}>
                  <td className="pr-2 py-1 text-gray-600 whitespace-nowrap">{r.label}</td>
                  <td className="font-semibold py-1 text-right text-gray-700">{r.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button
          className="mt-4 w-full bg-[#0CBB7D] text-white rounded py-2 font-bold"
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>
  );
};

const CarrierSelection = () => {
  const { id } = useParams();
  const [orderDetails, setOrderDetails] = useState({});
  const [plan, setPlan] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingButtons, setLoadingButtons] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [modalDetails, setModalDetails] = useState(null);
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const navigate = useNavigate();

  const openModal = (details) => {
    setModalDetails(details);
    setModalOpen(true);
  };
  const closeModal = () => setModalOpen(false);

  const handleShip = async (provider, finalCharges, courierServiceName, courier, details) => {
    setLoadingButtons((prev) => ({ ...prev, [courierServiceName]: true }));
    try {
      const payload = { id, provider, finalCharges, courierServiceName, courier, priceBreakup: details };
      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/${provider}/createShipment`,
        payload
      );
      console.log("Shipment creation response:",payload);
      if (response.data.error) throw new Error(response.data.error);
      toast.success(response?.data?.message || "Shipment created successfully");
      navigate("/dashboard/order");
    } catch (error) {
      // console.error("Error creating shipment:", error);
      toast.error(error.response?.data?.message[0] || "Something went wrong");
    } finally {
      setLoadingButtons((prev) => ({ ...prev, [courierServiceName]: false }));
    }
  };

  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const token = document.cookie.split("=")[1];
        const response = await axios.get(
          `${REACT_APP_BACKEND_URL}/Shiprocket/calculateShiprocketCargoCharges/${id}`,
          { headers: { authorization: `Bearer ${token}` } }
        );

        setOrderDetails(response.data.order);
        setPlan(response.data.updatedRates);
      } catch (error) {
        console.error("Error fetching order details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchOrderDetails();
  }, [id]);

  return (
    <div className="sm:p-2 p-1 text-gray-500">
      <ChargeBreakdownModal open={modalOpen} onClose={closeModal} details={modalDetails} />

      <h1 className="sm:text-[18px] text-[12px] font-[600] text-gray-700 mb-3">
        Order# <span className="text-[#0CBB7D]">{orderDetails?.orderId || ""}</span>
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 bg-white p-4 rounded-lg shadow">
        <div>
          <p className="text-[12px] text-gray-500">Pickup From</p>
          <p className="font-[600]">
            {orderDetails?.pickupAddress?.pinCode || ""},{" "}
            {orderDetails?.pickupAddress?.city || ""}
          </p>
        </div>
        <div>
          <p className="text-[12px] text-gray-500">Deliver To</p>
          <p className="font-[600]">
            {orderDetails?.receiverAddress?.pinCode || ""},{" "}
            {orderDetails?.receiverAddress?.city || ""}
          </p>
        </div>
        <div>
          <p className="text-[12px] text-gray-500">Payment Mode</p>
          <p className="font-[600]">{orderDetails?.paymentDetails?.method || ""}</p>
        </div>
        <div>
          <p className="text-[12px] text-gray-500">Applicable Weight</p>
          <p className="font-[600]">{orderDetails?.applicableWeight || ""} kg</p>
        </div>
        <div>
          <p className="text-[12px] text-gray-500">Order Value</p>
          <p className="font-[600]">₹{orderDetails?.paymentDetails?.amount || ""}</p>
        </div>
      </div>

      <div className="mt-4 bg-white sm:shadow rounded-lg sm:p-4">
        {loading ? (
          <div className="flex justify-center items-center h-40">
            <ThreeDotLoader />
          </div>
        ) : plan.length > 0 ? (
          <>
            {/* Mobile View */}
            <div className="block md:hidden">
              {plan.sort((a, b) => a.rate - b.rate).map((item) => (
                <div key={item._id} className="border rounded-lg p-4 mb-4">
                  <div className="flex items-center space-x-4 mb-2">
                    <img
                      src={carrierLogos[item.provider] || Shadowfax}
                      alt={item.courierServiceName}
                      className="w-10 h-10"
                    />
                    <div>
                      <h2 className="text-[12px] font-[600]">{item.courierServiceName}</h2>
                      <p className="text-[10px]">{item.courierType}</p>
                    </div>
                    <button onClick={() => openModal(item.details)} className="ml-auto text-[#0CBB7D]">
                      <FaInfoCircle />
                    </button>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-[12px]">Charges:</p>
                    <p className="font-[600]">₹{item.rate}</p>
                  </div>
                  <div className="flex justify-center">
                    <button
                      onClick={() => handleShip(item.provider, item.rate, item.courierServiceName, item.courier, item.details)}
                      disabled={loadingButtons[item.courierServiceName]}
                      className={`w-full mt-1 px-3 py-2 bg-[#0CBB7D] text-white rounded-lg text-[10px] font-[600] ${
                        loadingButtons[item.courierServiceName] ? "opacity-50" : ""
                      }`}
                    >
                      {loadingButtons[item.courierServiceName] ? "Processing..." : "Ship Now"}
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop View */}
            <div className="hidden md:block">
              <div className="grid grid-cols-6 font-[600] border-b pb-2">
                <p>Courier Partner</p>
                <p className="text-center">Mode</p>
                <p className="text-center">Weight</p>
                <p className="text-center">Charges</p>
                <p className="text-center">Info</p>
                <p className="text-center">Action</p>
              </div>
              {plan.map((item) => (
                <div key={item._id} className="grid grid-cols-6 items-center border-b py-4">
                  <div className="flex items-center space-x-4">
                    <img
                      src={carrierLogos[item.provider] || Shadowfax}
                      alt={item.courierServiceName}
                      className="w-14 h-14"
                    />
                    <div>
                      <h2 className="font-[600]">{item.courierServiceName}</h2>
                      <p className="text-[12px] text-gray-500">{item.courierType}</p>
                    </div>
                  </div>
                  <div className="flex justify-center">
                    {item.courierType === "air" ? <FaPlane /> : <FaTruck />}
                  </div>
                  <p className="text-center">{orderDetails?.applicableWeight} kg</p>
                  <p className="text-center font-[600]">₹{item.rate}</p>
                  <div className="flex justify-center">
                    <button onClick={() => openModal(item.details)} className="text-[#0CBB7D]">
                      <FaInfoCircle />
                    </button>
                  </div>
                  <div className="flex justify-center">
                    <button
                      onClick={() => handleShip(item.provider, item.rate, item.courierServiceName, item.courier, item.details)}
                      disabled={loadingButtons[item.courierServiceName]}
                      className={`px-3 py-1 bg-[#0CBB7D] text-white rounded text-[12px] ${
                        loadingButtons[item.courierServiceName] ? "opacity-50" : ""
                      }`}
                    >
                      {loadingButtons[item.courierServiceName] ? "Processing..." : "Ship Now"}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <p className="text-center py-4">No Courier Serviceable for this Pincode</p>
        )}
      </div>
    </div>
  );
};

export default CarrierSelection;
